import React from 'react'
import styled from 'styled-components/macro'
import {
  Title, Text, Button, Icon
} from 'components/atoms'
import { useParams, useHistory } from 'react-router-dom'
import { PeopleDetail } from 'containers';

const PeopleSideDetail = () => {
  const { subweb, peopleId } = useParams()
  const history = useHistory()

  const handleCloseDetail = () => {
    history.push(`/${subweb}/people`)
  }

  return (
    <>
      <Top>
        <Title as="h3" modifiers={['fixSpacing']}>
          Editar dados
        </Title>
        <Top.Action isDetail={!!peopleId}>
          <Button modifiers={['invisibleDarker']} onClick={handleCloseDetail}>
            <Icon icon="close" />
          </Button>
        </Top.Action>
      </Top>
      {(peopleId && subweb)
        ? (
          <PeopleDetail subweb={subweb} peopleId={peopleId} />
        )
        : (
          <Text>Selecione uma pessoa para editar.</Text>
        )
      }
    </>
  )
}

const Top = styled.div`
  margin-bottom: ${props => props.theme.spacing.xl4};
  padding-bottom: ${props => props.theme.spacing.xl3};
  display: flex;
  justify-content: space-between;
  align-items: center;
`

Top.Action = styled.div`
  visibility: ${props => (props.isDetail ? 'visible' : 'hidden')};
`

export default PeopleSideDetail
